export default { 
  name : 'Parent Device ESN',
  objectType : 'wireless',
  valueType : 'string',
  displayName : 'Parent Device ESN',
  get : () => null
}
